import { QuestionnaireStatus, UserQuestionnaireType } from '@/components/decision-tree/types';

export default function useQuestionnaireData(providedQuestionnaireData: UserQuestionnaireType | undefined) {
  const questionnaireData = providedQuestionnaireData;

  const questionnaireStatus = questionnaireData?.status as QuestionnaireStatus;
  const iDontKnowAnswers = questionnaireData?.questionnaireStatistics?.iDontKnowAnswersCount ?? 0;
  const answeredQuestions = questionnaireData?.questionnaireStatistics?.answeredQuestionsCount ?? 0;
  const totalQuestions = questionnaireData?.questionnaireStatistics?.totalQuestionsCount ?? 0;
  const totalAnsweredQuestions = answeredQuestions - iDontKnowAnswers;
  const assessmentProgress = Math.round((totalAnsweredQuestions / totalQuestions) * 100);

  const answeredRequiredQuestionsCount =
    questionnaireData?.questionnaireStatistics?.answeredRequiredQuestionsCount ?? 0;
  const requiredQuestionsCount = questionnaireData?.questionnaireStatistics?.requiredQuestionsCount ?? 0;
  const currentSectionAssessmentProgress = Math.round((answeredRequiredQuestionsCount / requiredQuestionsCount) * 100);

  return {
    answeredQuestions,
    assessmentProgress,
    currentSectionAssessmentProgress,
    iDontKnowAnswers,
    questionnaireStatus,
    totalAnsweredQuestions,
    totalQuestions,
  };
}
